<template>
  <iframe
    v-if="$store.state.userEmail"
    allowfullscreen="true"
    class="chat-frame__wrapper"
    :src="url"
  />
  <v-alert v-else :value="true" type="error" style="margin-top: -2px; width: 100%"
    >{{ $t('email_not_found') }}
  </v-alert>
</template>
<script>
import sign from 'jwt-encode'
import { mapGetters } from 'vuex'
export default {
  props: {
    user: {
      type: [Object],
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    token() {
      const currentTime = new Date().getTime()
      const oneHour = 60 * 60 * 1000
      const newTime = currentTime + oneHour
      const secret = this.selectedBot.warroom_iframe_secret
      const data = {
        userEmail: this.$store.state.userEmail,
        redirectPath: `/iframe/thread/${this.user.platform_thread_id}?postId=${this.user.platform_post_id}`,
        exp: newTime
      }
      return sign(data, secret)
    },
    url() {
      return `https://web.warroom.wisesight.com/iframe/login/client/${this.selectedBot.warroom_iframe_clientid}/${this.token}`
    }
  }
}
</script>
<style scoped>
.chat-frame__wrapper {
  display: block;
  overflow: hidden;
  border: none;
  width: 100%;
  height: 100%;
  padding-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/Warroom/ChatIframe.vue